import Router from 'vue-router';

import LoginPage from '@/views/Login.vue';
import DashboardPage from '@/views/Dashboard.vue';
import ManagerPreferencesPage from '@/views/ManagerPreferences.vue';
import TestPage from '@/views/Test.vue';

import SystemRoutes from '@/views/system/SystemRoutes';
import LoraRoutes from '@/views/lora/LoraRoutes';
import IdentityRoutes from '@/views/identity/IdentityRoutes';
import NetworkRoutes from '@/views/network/NetworkRoutes';


export function buildRouter(): Router {
  const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/',
        redirect: 'dashboard',
      },
      {
        path: '/login',
        name: 'login',
        component: LoginPage,
        meta: {
          fullPage: true,
          public: true,
        },
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: DashboardPage,
        meta: {
          label: 'Dashboard',
        },
      },
      {
        path: '/system',
        name: 'system',
        component: () => import(/* webpackChunkName: "system" */ './views/system/System.vue'),
        meta: {
          label: 'System',
        },
        children: SystemRoutes.Routes,
      },
      {
        path: '/network',
        name: 'network',
        component: () => import(/* webpackChunkName: "network" */ './views/network/NetworkPage.vue'),
        meta: {
          label: 'Network',
        },
        children: NetworkRoutes.Routes,
      },
      {
        path: '/lora',
        name: 'lora',
        component: () => import(/* webpackChunkName: "lora" */ './views/lora/Lora.vue'),
        meta: {
          label: 'LoRa',
        },
        children: LoraRoutes.Routes,
      },
      {
        path: '/identity',
        name: 'identity',
        component: () => import(/* webpackChunkName: "identity" */ './views/identity/Identity.vue'),
        meta: {
          label: 'Users & Groups',
        },
        children: IdentityRoutes.Routes,
      },
      {
        path: '/preferences',
        name: 'manager-preferences',
        component: ManagerPreferencesPage,
        meta: {
          label: 'Manager preferences',
        },
      },
      {
        path: '/test',
        name: 'test',
        component: TestPage,
        meta: {
          label: 'Test',
        },
      },
    ],
  });

  registerLoginGuard(router);

  return router;
}

function registerLoginGuard(router: Router): Router {
  router.beforeEach((to, from, next) => {

    // const loggedIn = !!settingsService.get(Setting.Token);
    const loggedIn = true; // TODO: restore check from store

    const isPublic = to.matched.some((record) => record.meta.public);

    if (!isPublic && !loggedIn) {
      next({
        name: 'login',
        params: {nextUrl: to.fullPath},
      });
    }

    next();
  });

  return router;
}


